import React from "react";
import { Mui } from "../../libraries/material";

const SexualHealth = Mui.createSvgIcon(
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g
      id="Artboard"
      transform="translate(-309.000000, -46.000000)"
      fillRule="nonzero"
    >
      <g id="sexual_health" transform="translate(309.000000, 46.000000)">
        <path
          d="M17.2698413,0 C14.9206349,0 13.1111111,1.3015873 12,3.3015873 C10.9206349,1.33333333 9.07936508,0 6.73015873,0 C2.95238095,0 0,3.01587302 0,7.3015873 C0,12.4444444 4.31746032,17.5238095 11.1428571,21.8730159 C11.3968254,22.031746 11.7777778,22.1904762 12,22.1904762 C12.2539683,22.1904762 12.6349206,22.031746 12.8888889,21.8730159 C19.6825397,17.5238095 24,12.4761905 24,7.3015873 C24,3.01587302 21.0793651,0 17.2698413,0 Z"
          id="Path"
          fill="currentColor"
          fillOpacity="0.5"
        ></path>
        <path
          d="M17.047619,12 C17.047619,12.5714286 16.6666667,12.952381 16.0952381,12.952381 L13.8730159,12.952381 L13.8730159,15.1746032 C13.8730159,15.7460317 13.4920635,16.1269841 12.9206349,16.1269841 L11.1111111,16.1269841 C10.5396825,16.1269841 10.1587302,15.7460317 10.1587302,15.1746032 L10.1587302,12.952381 L7.93650794,12.952381 C7.36507937,12.952381 6.98412698,12.5714286 6.98412698,12 L6.98412698,10.1904762 C6.98412698,9.61904762 7.36507937,9.23809524 7.93650794,9.23809524 L10.1587302,9.23809524 L10.1587302,7.01587302 C10.1587302,6.44444444 10.5396825,6.06349206 11.1111111,6.06349206 L12.9206349,6.06349206 C13.4920635,6.06349206 13.8730159,6.44444444 13.8730159,7.01587302 L13.8730159,9.23809524 L16.0952381,9.23809524 C16.6666667,9.23809524 17.047619,9.61904762 17.047619,10.1904762 L17.047619,12 Z"
          id="Path"
          fill="currentColor"
        ></path>
      </g>
    </g>
  </g>,
  "sexual health"
);

export default SexualHealth;
